// @flow

import { useState, useEffect } from 'react';
import { type LookAndFeel, type LookAndFeelLoadingPage, type LookAndFeelRoot } from '@tectonics/look-and-feel';

type DynamicLookAndFeel = [boolean, ?LookAndFeelLoadingPage, ?LookAndFeelRoot];

const defaultLookAndFeelLoadingPageState: () => LookAndFeelLoadingPage = () => () => null;

export function useDynamicLookAndFeel(lookAndFeel: ?LookAndFeel): DynamicLookAndFeel {
  const [loading, setLoading] = useState<boolean>(true);
  const [LafLoadingPage, setLafLoadingPage] = useState<?LookAndFeelLoadingPage>(
    lookAndFeel && lookAndFeel.getLoadingPage ? defaultLookAndFeelLoadingPageState : null
  );
  const [LafMainPage, setLafMainPage] = useState<?LookAndFeelRoot>();

  useEffect(() => {
    if (!lookAndFeel) return;

    (async () => {
      const getLoadingPage = lookAndFeel.getLoadingPage;

      if (getLoadingPage) {
        setLoading(true);
        const loadingPageModule = await getLoadingPage();
        setLafLoadingPage((): LookAndFeelLoadingPage => loadingPageModule.default);
      }
    })();
  }, [lookAndFeel]);

  useEffect(() => {
    if (!lookAndFeel) return;

    (async () => {
      setLoading(true);
      const mainPageModule = await lookAndFeel.getRootComponent();
      setLafMainPage((): LookAndFeelRoot => mainPageModule.default);
      setLoading(false);
    })();
  }, [lookAndFeel]);

  return [loading, LafLoadingPage, LafMainPage];
}
